(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giften-gift-finder"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Occasion → destination collection URL
  var occasionMap = {
    'thank-you': '/collections/thank-you',
    'welcome': '/collections/employee-client-gifts',
    'birthday': '/collections/gift-boxes',
    'sympathy': '/collections/sympathy-gifts',
    'get-well': '/collections/get-well-gifts',
    'holiday': '/collections/holiday',
    'just-because': '/collections/gift-boxes'
  };

  // Budget → {gte, lte} price filter values (USD).
  // Uses Shopify's native filter.v.price.gte / lte URL params.
  var budgetRange = {
    'under-100': { gte: null, lte: 99 },
    '100-150':   { gte: 100,  lte: 150 },
    'over-150':  { gte: 150,  lte: null }
  };

  document.querySelectorAll('[data-gift-finder]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var data = new FormData(form);
      var occasion = data.get('occasion');
      var recipient = data.get('recipient');
      var budget = data.get('budget');

      // Base: occasion collection if picked, otherwise full ready-to-ship.
      var base = occasion && occasionMap[occasion]
        ? occasionMap[occasion]
        : '/collections/gift-boxes';

      var params = [];
      if (recipient) {
        params.push('recipient=' + encodeURIComponent(recipient));
      }
      if (budget && budgetRange[budget]) {
        var range = budgetRange[budget];
        if (range.gte !== null) {
          params.push('filter.v.price.gte=' + range.gte);
        }
        if (range.lte !== null) {
          params.push('filter.v.price.lte=' + range.lte);
        }
      }

      var url = base + (params.length ? '?' + params.join('&') : '');
      window.location.href = url;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
